<!-- ================用户端-营在规划-研学活动列表====================-->
<template>
    <div class="excursion-page">
        <home-head />
        <div class="excursion-body">
            <div class="excursion-inner">
                <!-- 标题区 -->
                <div class="excursion-header">
                    <div class="excursion-title-box">
                        <div class="excursion-title">以美润心 营在规划</div>
                        <div class="excursion-subtitle">沉浸研学 一键预约</div>
                    </div>
                    <div class="excursion-actions">
                        <div class="back-btn" @click="goHome">返回首页</div>
                        <div class="search-row">
                            <input class="search-input" type="text" placeholder="请输入关键词"
                                   v-model="queryParams.excursionTitle" @keyup.enter="handleSearch" />
                            <div class="search-btn" @click="handleSearch">搜索</div>
                        </div>
                    </div>
                </div>

                <!-- 研学营切换 -->
                <div class="excursion-tabs">
                    <div class="tab-item" v-for="item in campList" :key="item.dictKey"
                         :class="{ active: queryParams.campKey === item.dictKey }"
                         @click="changeCamp(item.dictKey)">{{ item.dictValue }}</div>
                </div>

                <!-- 研学活动列表 -->
                <div class="camp-list" v-loading="loading">
                    <div class="camp-card" v-for="item in dataList" :key="item.excursionId" @click="handleDetail(item)">
                        <div class="camp-cover">
                            <img class="img-100" :src="item.excursionCover || defaultCover" :alt="item.excursionTitle" />
                        </div>
                        <div class="camp-info">
                            <div class="camp-title" :title="item.excursionTitle">{{ item.excursionTitle }}</div>
                            <div class="camp-subtitle" :title="item.excursionSubtitle">{{ item.excursionSubtitle }}</div>
                            <div class="camp-tags">
                                <div class="camp-tag">类型：{{ campName(item.campKey) }}</div>
                                <div class="camp-tag" :title="item.excursionTheme">主题：{{ item.excursionTheme }}</div>
                                <div class="camp-tag">活动时间：{{ formatTimeRange(item) }}</div>
                            </div>
                        </div>
                        <div class="camp-detail-btn" @click.stop="handleDetail(item)">查看详细行程</div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && dataList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="total > 0">
                    <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageExcursion } from "@/api/admin/excursion";
import { queryDict } from "@/api/admin/dict";
import { timestampDate } from "@/utils/date";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "excursionPage",
    data() {
        return {
            loading: false,
            total: 0,
            dataList: [],
            campList: [],
            queryParams: {
                excursionTitle: '',
                campKey: '',
                pageNum: 1,
                pageSize: 10,
            },
            defaultCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.restoreFromQuery();
        this.handleQueryDict();
    },
    mounted() {},
    methods: {
        /* ===============从 URL 查询中恢复查询条件===================== */
        restoreFromQuery() {
            const q = this.$route.query || {};
            if (q.campKey) this.queryParams.campKey = q.campKey;
            if (q.excursionTitle) this.queryParams.excursionTitle = q.excursionTitle;
            if (q.pageNum) this.queryParams.pageNum = Number(q.pageNum) || 1;
            if (q.pageSize) this.queryParams.pageSize = Number(q.pageSize) || 10;
        },

        /* ===============将当前查询条件同步到 URL===================== */
        syncQueryToUrl() {
            const query = {};
            if (this.queryParams.campKey) query.campKey = this.queryParams.campKey;
            if (this.queryParams.excursionTitle) query.excursionTitle = this.queryParams.excursionTitle;
            query.pageNum = this.queryParams.pageNum;
            query.pageSize = this.queryParams.pageSize;
            this.$router.replace({ query }).catch(() => {});
        },

        /* ===============字典查询===================== */
        handleQueryDict() {
            queryDict({ code: 'museum_camp' }).then(res => {
                if (res.data.code === 1) {
                    this.campList = res.data.data || [];
                    // 未指定研学营时默认选中第一个
                    if (this.campList.length > 0 && !this.queryParams.campKey) {
                        this.queryParams.campKey = this.campList[0].dictKey;
                    }
                }
                this.pageList();
            });
        },

        /* ===============分页查询===================== */
        pageList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            this.syncQueryToUrl();
            pageExcursion(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.dataList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============筛选与搜索===================== */
        changeCamp(campKey) {
            if (this.queryParams.campKey === campKey) return;
            this.queryParams.campKey = campKey;
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },

        /* ===============工具方法===================== */
        campName(campKey) {
            const camp = this.campList.find(item => item.dictKey === campKey);
            return camp ? camp.dictValue : (campKey || '--');
        },
        formatTimeRange(item) {
            const begin = item.beginTime ? timestampDate(Number(item.beginTime)) : '';
            const end = item.endTime ? timestampDate(Number(item.endTime)) : '';
            if (begin && end) return begin + '至' + end;
            return begin || end || '--';
        },

        /* ===============跳转===================== */
        goHome() {
            this.$router.push("/museum/home");
        },
        handleDetail(item) {
            this.$router.push({
                path: '/edu/excursionInfo',
                query: { excursionId: item.excursionId },
            });
        },
    }
}
</script>

<style scoped>
.excursion-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.excursion-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.excursion-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 标题区 */
.excursion-header {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
    position: relative;
}

.excursion-title-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
}

.excursion-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.excursion-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.excursion-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    flex-shrink: 0;
    z-index: 1;
}

.search-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 200px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 研学营切换 */
.excursion-tabs {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-shrink: 0;
    flex-wrap: wrap;
}

.tab-item {
    min-width: 110px;
    height: 36px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.tab-item:hover {
    background-color: #fff5f5;
}

.tab-item.active {
    background-color: #b22222;
    color: #ffffff;
    border-color: #b22222;
}

/* 研学活动列表 */
.camp-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 60px;
    padding-top: 4px;
}

.camp-list::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.camp-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.camp-list::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.camp-list::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}

.camp-card {
    width: 100%;
    display: flex;
    align-items: stretch;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.25s ease;
    flex-shrink: 0;
}

.camp-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.camp-cover {
    width: 220px;
    flex-shrink: 0;
    background-color: #f3f4f6;
    overflow: hidden;
}

.camp-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.camp-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    box-sizing: border-box;
}

.camp-title {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.camp-subtitle {
    width: 100%;
    font-size: 14px;
    color: #6b7280;
    font-family: sans-serif;
    margin-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.camp-tags {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: auto;
    padding-top: 12px;
}

.camp-tag {
    max-width: 320px;
    padding: 4px 12px;
    background-color: #f3f4f6;
    border-radius: 2px;
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

.camp-detail-btn {
    align-self: center;
    flex-shrink: 0;
    margin: 0 24px;
    height: 34px;
    line-height: 32px;
    padding: 0 18px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.camp-detail-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
    box-sizing: border-box;
}

.empty-icon {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 分页 */
.pagination-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.pagination-wrapper .el-pagination__total {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pagination__jump {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pager li {
    font-size: 13px;
    color: #4b5563;
}

.pagination-wrapper .el-pager li.active {
    background-color: #b22222;
    color: #ffffff;
}

.pagination-wrapper .el-select .el-input__wrapper {
    height: 28px;
    min-height: 28px;
    font-size: 13px;
}

@media (max-width: 1024px) {
    .excursion-title { font-size: 20px; }
    .excursion-subtitle { font-size: 13px; }
    .search-input { width: 160px; }
    .camp-cover { width: 180px; }
}

@media (max-width: 768px) {
    .excursion-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .excursion-title-box { position: static; transform: none; align-items: flex-start; }
    .excursion-actions { width: 100%; align-items: stretch; }
    .search-row { width: 100%; }
    .search-input { flex: 1; }
    .camp-cover { width: 140px; }
    .camp-title { font-size: 16px; }
    .camp-detail-btn { margin: 0 12px 12px; align-self: flex-end; }
    .camp-card { flex-wrap: wrap; }
}
</style>
